

function NotFound(props:any){
    return <>ROUTE NOT FOUND!</>
}

export default NotFound;